import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "login-wrapper" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "dark-mode action-item" }
const _hoisted_5 = { class: "login" }
const _hoisted_6 = {
  key: 2,
  class: "logged-in-user"
}
const _hoisted_7 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavMenuItem = _resolveComponent("NavMenuItem")!
  const _component_Light = _resolveComponent("Light")!
  const _component_Dark = _resolveComponent("Dark")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DotsLoader = _resolveComponent("DotsLoader")!
  const _component_LoginModal = _resolveComponent("LoginModal")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (navItem) => {
        return (_openBlock(), _createBlock(_component_NavMenuItem, {
          key: navItem.value,
          label: navItem.name,
          to: { name: navItem.value },
          active: _ctx.$route.name == navItem.value
        }, null, 8, ["label", "to", "active"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isDarkMode)
            ? (_openBlock(), _createBlock(_component_Light, {
                key: 0,
                color: 'rgb(255 255 255 / 60%)'
              }))
            : (_openBlock(), _createBlock(_component_Dark, {
                key: 1,
                color: 'rgb(255 255 255 / 60%)'
              }))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["action-item language-dropdown", { open: _ctx.dropdownOpened }])
        }, [
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.currentLanguage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentLanguage) = $event)),
            open: _ctx.dropdownOpened,
            "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dropdownOpened) = $event)),
            options: _ctx.languageOptions
          }, {
            default: _withCtx(() => [
              (_ctx.selectedLanguageIcon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.selectedLanguageIcon), { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "open", "options"])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.accessToken)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.commit('auth/SHOW_LOGIN_MODAL', true)))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Login", -1)
              ]))]),
              _: 1
            }))
          : (_ctx.accessToken && !_ctx.user.id)
            ? (_openBlock(), _createBlock(_component_DotsLoader, {
                key: 1,
                small: ""
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.user.avatar,
                  alt: _ctx.user.name
                }, null, 8, _hoisted_7),
                _createVNode(_component_Dropdown, { options: _ctx.userOptions }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.user.name), 1)
                  ]),
                  _: 1
                }, 8, ["options"])
              ]))
      ])
    ]),
    (_ctx.showLoginModal)
      ? (_openBlock(), _createBlock(_component_LoginModal, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$store.commit('auth/SHOW_LOGIN_MODAL', false))),
          img: "Welcome.png",
          name: "Welcome"
        }))
      : _createCommentVNode("", true)
  ]))
}